export function formatArticleDate(published: string | null, created?: string | null): string | null {
  const raw = published ?? created ?? null;
  if (!raw) return null;
  const d = new Date(raw);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffH = Math.floor(diffMs / (1000 * 60 * 60));
  if (diffH < 1) return "netop nu";
  if (diffH < 24) return `for ${diffH} t. siden`;
  const diffD = Math.floor(diffH / 24);
  if (diffD === 1) return "i går";
  if (diffD < 7) return `for ${diffD} dage siden`;
  return d.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
}

export function formatUpdatedAt(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) {
    return `Opdateret i dag kl. ${d.toLocaleTimeString("da-DK", { hour: "2-digit", minute: "2-digit" })}`;
  }
  const yest = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  if (d.toDateString() === yest.toDateString()) return "Opdateret i går";
  return `Opdateret ${d.toLocaleDateString("da-DK", { day: "numeric", month: "long" })}`;
}

export function formatPublishedDate(iso: string | null): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });
}
